import { colors } from '../../colors';
var input = {
  textColor: colors.charcoalGrey
};
export default input;